<template>
  <div class="dashboard">
    <div class="row">
      <div class="flex md12 xs12">
        <sp-360-panel class="chart-widget"
          :title="$t('mainDashboard.wordCloud.title')"
          :footerText="$t('rodape.fonteData', {fonte : metadados.origem, data : metadados.dataReferencia})"
          :footerComplementar="$t('mainDashboard.wordCloud.footerComplementar')">
          <sp-tag-cloud ref="tagcloud"></sp-tag-cloud>
        </sp-360-panel>
      </div>
    </div>
  </div>
</template>

<script>
import SpMap from '@/components/maps/360-maps/SPMap.vue'
import SpTagCloud from '@/components/dashboard/face-board/156-tag-cloud'
import _ from 'lodash'
import mapaDeCalor from '@/services/MapaDeCalor'
import MetodosGlobais from '@/utils/MetodosGlobais'
import AutoUpdate from '@/services/AutoUpdate'
import CorUtil from '@/utils/CorUtils'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import RaioX from "@/components/dashboard/raiox/raio-x-regiao";

export default {
  name: 'dashboard',
  mixins: [AutoUpdate],
  components: {
    SpMap,
    SpTagCloud,
    Sp360Panel,
    RaioX,
  },
  data () {
    return {
      intervalo: 0,
      titulo: 'Bem vindo ao SP360',
      rotulo_img: 'Dashboard Inicial em construção',
      ultimoClick: null,
      munAtual: this.$t('mainDashboard.general'),
      newData: {},
      heatMax: {},
      heatMin: {},
      hoverColor: {},
      metadados: {
        origem: '',
        dataReferencia: ''
      }
    }
  },
  created () {
    Promise.all([
      this.$store.dispatch('servicos156/buscarTopAssuntosDemandados', { top: 30, intervalo: 'DESDE_SEMPRE' }),
    ]).then(response => {
      this.metadados.origem = response[0].data.sigla_orgao + '-' + response[0].data.fonte
      this.metadados.dataReferencia = new Date(response[0].data.data_referencia_dado).toLocaleDateString('pt-BR')
      let d = []
      response[0].data.data.forEach(e => {
        d.push({ tag: e.nome, value: e.abertas })
      })
      this.newData = _.orderBy(d, ['value'], 'desc')

      let chart = this.$refs.tagcloud.defineChart()
      this.$refs.tagcloud.setChart(chart)
      let series = this.$refs.tagcloud.defineSeries(
        chart,
        this.newData,
        'tag',
        'value',
        null,
        null,
        CorUtil.getCorPorNomeSp360('Vermelho-claro'), //Max
        CorUtil.getCorPorNomeSp360('azul-colombia-claro'), //Min
        this.$themes.success)
      this.$refs.tagcloud.setSeries(series)
    })
  },
}

</script>

<style lang="scss">
  @media (min-width: 1000px) {
      #flex-box{
        display: flex;
      }
      .tabela tr{
        max-height: 34px;
      }
  }
</style>
